<div class="container-fluid" style="margin-top: 15px">
  <div *ngIf="loading"><i class="fas fa-spinner fa-pulse"></i> Loading...</div>

  <div class="row">
    <div class="col-md-12">
      <span [style.color]="errorCount > 0 ? '#b00020' : 'inherit'">
        <b>{{ errorCount }}</b> error(s), <b>{{ warningCount }}</b> warning(s)
      </span>
      <button mat-raised-button class="piButton" style="margin-left: 15px" (click)="validate()">Validate</button>
      <button mat-raised-button class="piButton" style="margin-left: 15px" (click)="regenerateAll()" [disabled]="regeneratingAll">Regenerate all ADMs</button>
      <span class="text-muted" style="margin-left: 15px">A definition with errors cannot be used to build any Agent Data Model.</span>
    </div>
  </div>

  <mat-tab-group style="margin-top: 10px" [(selectedIndex)]="selectedTab">
    <!-- TABLES AND COLUMNS -->
    <mat-tab label="Tables & Columns">
      <div class="row" style="margin-top: 10px">
        <div class="col-md-5">
          <mat-form-field class="full-width">
            <mat-label>Table</mat-label>
            <mat-select [(value)]="selectedTableId" (valueChange)="onTableChange()">
              <mat-option *ngFor="let t of tables" [value]="t.admTableId">{{ t.tableName }}<span *ngIf="t.retired"> (retired)</span></mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-7" style="margin-top: 10px">
          <button mat-raised-button class="piButton" (click)="newTable()">New table</button>&nbsp;
          <ng-container *ngIf="selectedTableId !== null">
            <button mat-raised-button class="piButton" (click)="editSelectedTable()">Edit table</button>&nbsp;
            <button mat-raised-button class="piButton" (click)="newColumn()">New column</button>&nbsp;
            <button mat-raised-button class="piButton" (click)="newFieldGroup()">New field group</button>
          </ng-container>
        </div>
      </div>

      <p class="text-muted" *ngIf="selectedTableId !== null" style="margin-top: 4px">
        Field groups are display-only: they group this table's columns under a heading in the Agent Data Model picker
        and have no effect on materialization.
      </p>

      <div *ngIf="selectedTableId !== null && fieldGroupsOf(selectedTableId).length > 0" style="margin-bottom: 10px">
        <b>Field groups:</b>&nbsp;
        <ng-container *ngFor="let g of fieldGroupsOf(selectedTableId); let last = last">
          <a href="#" (click)="editFieldGroup(g); false">{{ g.name }}</a><span *ngIf="!last">, </span>
        </ng-container>
      </div>

      <!-- Bulk move of the selected columns to another field group -->
      <div *ngIf="selectedTableId !== null && selectedColumnIds.size > 0"
           style="position: sticky; top: 0; z-index: 5; background: #fff8e1; border: 1px solid #f0d58a; border-radius: 4px; padding: 8px 12px; margin: 10px 0">
        <div class="row">
          <div class="col-md-3" style="padding-top: 14px"><b>{{ selectedColumnIds.size }}</b> column{{ selectedColumnIds.size === 1 ? "" : "s" }} selected</div>
          <div class="col-md-3">
            <mat-form-field class="full-width">
              <mat-label>Move to field group</mat-label>
              <mat-select [(value)]="moveTargetValue">
                <mat-option *ngFor="let t of moveTargets" [value]="t.value">{{ t.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="full-width" *ngIf="moveTargetValue === 'new'">
              <mat-label>New field group name</mat-label>
              <input matInput [(ngModel)]="newGroupName" autocomplete="off" />
            </mat-form-field>
          </div>
          <div class="col-md-3" style="padding-top: 10px">
            <button mat-raised-button class="piButton" (click)="moveSelected()" [disabled]="!canMove">Move</button>&nbsp;
            <button mat-stroked-button (click)="clearSelection()" [disabled]="moving">Clear</button>
            <span *ngIf="moving" style="margin-left: 8px"><i class="fas fa-spinner fa-pulse"></i></span>
          </div>
        </div>
        <div class="text-muted" style="font-size: 90%">Display-only: the moved columns go to the end of the chosen group, in their current order.</div>

        <hr style="margin: 8px 0" />
        <div class="row">
          <div class="col-md-12"><b>Set options on the selected columns</b> <span class="text-muted">(leave "No change" for the ones you do not want to touch)</span></div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="full-width"><mat-label>Selectable</mat-label>
              <mat-select [(value)]="flagValues.selectable"><mat-option *ngFor="let c of flagChoices" [value]="c.value">{{ c.label }}</mat-option></mat-select></mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="full-width"><mat-label>Key (always kept)</mat-label>
              <mat-select [(value)]="flagValues.alwaysKeep"><mat-option *ngFor="let c of flagChoices" [value]="c.value">{{ c.label }}</mat-option></mat-select></mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="full-width"><mat-label>Sensitive</mat-label>
              <mat-select [(value)]="flagValues.isSensitive"><mat-option *ngFor="let c of flagChoices" [value]="c.value">{{ c.label }}</mat-option></mat-select></mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="full-width"><mat-label>High cardinality</mat-label>
              <mat-select [(value)]="flagValues.isHighCardinality"><mat-option *ngFor="let c of flagChoices" [value]="c.value">{{ c.label }}</mat-option></mat-select></mat-form-field>
          </div>
          <div class="col-md-3" style="padding-top: 10px">
            <button mat-raised-button class="piButton" (click)="applyFlags()" [disabled]="!canApplyFlags">Apply options</button>
            <span *ngIf="applyingFlags" style="margin-left: 8px"><i class="fas fa-spinner fa-pulse"></i></span>
          </div>
        </div>
        <div class="text-muted" style="font-size: 90%">Flattened columns take Sensitive and High cardinality from their source column and have no Key option, so those are skipped for them.</div>
      </div>

      <ng-container *ngIf="selectedTableId !== null" >
        <ng-container *ngFor="let group of columnsByFieldGroup(selectedTableId); trackBy: trackByFieldGroupId">
          <h5 style="margin-top: 14px; display: flex; align-items: center">
            <mat-checkbox *ngIf="group.columns.length > 0" style="margin-right: 6px" title="Select every column in this group"
              [checked]="groupAllSelected(group)" [indeterminate]="groupSomeSelected(group)" (change)="toggleGroup(group, $event.checked)"></mat-checkbox>
            {{ group.name }}
          </h5>
          <p class="text-muted" *ngIf="group.columns.length > 1" style="margin-bottom: 4px">Drag <span class="fas fa-grip-vertical"></span> to reorder.</p>
          <table class="table table-sm">
            <thead><tr><th></th><th>Column</th><th>Output name</th><th>Warehouse type</th><th>Flags</th></tr></thead>
            <tbody cdkDropList [cdkDropListData]="group.columns" (cdkDropListDropped)="dropColumn(group, $event)">
              <tr *ngFor="let c of group.columns; trackBy: trackByColumnId" cdkDrag [style.opacity]="c.retired ? 0.5 : 1">
                <td style="white-space: nowrap">
                  <mat-checkbox [checked]="selectedColumnIds.has(c.admTableColumnId)" (change)="toggleColumn(c.admTableColumnId, $event.checked)" style="margin-right: 4px"></mat-checkbox>
                  <span class="fas fa-grip-vertical" cdkDragHandle style="cursor: move; margin-right: 8px" title="Drag to reorder"></span>
                  <a href="#" (click)="editColumn(c); false" *ngIf="c.columnKind === 0"><span class="fas fa-edit"></span></a>
                </td>
                <td>{{ c.columnName }} <span class="text-muted" *ngIf="c.columnKind === 1">(flattened)</span></td>
                <td>{{ c.outputName }}</td>
                <td>{{ c.warehouseType || "unsupported" }}</td>
                <td class="text-muted">
                  <span *ngIf="c.selectable">selectable </span><span *ngIf="c.alwaysKeep">key </span><span *ngIf="c.isSensitive">sensitive </span>
                  <span *ngIf="c.isHighCardinality">high-cardinality </span><span *ngIf="c.retired">retired</span>
                </td>
              </tr>
            </tbody>
            <tr *ngIf="group.columns.length === 0"><td></td><td class="text-muted" colspan="4">No columns in this group yet.</td></tr>
          </table>
        </ng-container>
      </ng-container>
    </mat-tab>

    <!-- RELATIONSHIPS -->
    <mat-tab label="Relationships">
      <div class="row" style="margin-top: 10px">
        <div class="col-md-5">
          <mat-form-field class="full-width">
            <mat-label>Parent table</mat-label>
            <mat-select [(value)]="selectedTableId" (valueChange)="onFlattenedTableChange()">
              <mat-option *ngFor="let t of tables" [value]="t.admTableId">{{ t.tableName }}<span *ngIf="t.retired"> (retired)</span></mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-7" style="margin-top: 10px">
          <button mat-raised-button class="piButton" (click)="newRelationship()">New relationship</button>
        </div>
      </div>
      <p class="text-muted" style="margin-top: 4px">Showing relationships whose parent (From side) is the table above.</p>

      <table class="table table-sm">
        <tr><th></th><th>Relationship</th><th>Cardinality</th><th>Kind</th></tr>
        <tr *ngFor="let r of relationshipsOf(selectedTableId)" [style.opacity]="r.retired ? 0.5 : 1">
          <td><a href="#" (click)="editRelationship(r); false"><span class="fas fa-edit"></span></a></td>
          <td>{{ relationshipLabel(r) }}</td>
          <td>{{ cardinalities[r.cardinality].label }}</td>
          <td>{{ relationshipKinds[r.kind].label }}<span *ngIf="r.retired"> (retired)</span></td>
        </tr>
        <tr *ngIf="relationshipsOf(selectedTableId).length === 0"><td></td><td class="text-muted" colspan="3">No relationships have this table as their parent yet.</td></tr>
      </table>
    </mat-tab>

    <!-- FLATTENED COLUMNS -->
    <mat-tab label="Flattened Columns">
      <p class="text-muted" style="margin-top: 10px">
        A flattened column shows a lookup's value as an ordinary column of the parent table - for example
        <i>department name</i> on a job posting, reached through titles. Build the path one relationship at a time.
      </p>

      <div class="row">
        <div class="col-md-5">
          <mat-form-field class="full-width">
            <mat-label>Parent table</mat-label>
            <mat-select [(value)]="selectedTableId">
              <mat-option *ngFor="let t of tables" [value]="t.admTableId">{{ t.tableName }}<span *ngIf="t.retired"> (retired)</span></mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-7" style="margin-top: 10px">
          <button mat-raised-button class="piButton" (click)="newFlattened()">New flattened column</button>&nbsp;
          <button mat-raised-button class="piButton" (click)="rerouteLineage()" [disabled]="flattenedColumnsOf(selectedTableId).length === 0">Re-route lineage</button>&nbsp;
          <button mat-raised-button class="piButton" (click)="regenerateStale()" [disabled]="staleLayoutCount === 0 || regeneratingStale">Regenerate affected ADMs ({{ staleLayoutCount }})</button>
        </div>
      </div>
      <mat-form-field class="full-width">
        <mat-label>Search flattened columns</mat-label>
        <input matInput [(ngModel)]="flattenedSearch" name="flattenedSearch" placeholder="Output name, field group, path or source column" />
      </mat-form-field>
      <p class="text-muted" style="margin-top: 4px">Showing flattened columns whose parent is the table above<span *ngIf="flattenedSearch"> and that match the search</span>.</p>

      <table class="table table-sm">
        <tr><th></th><th>Output name</th><th>Field group</th><th>Path</th></tr>
        <tr *ngFor="let c of searchedFlattenedColumns(selectedTableId)" [style.opacity]="c.retired ? 0.5 : 1">
          <td><a href="#" (click)="editFlattened(c); false"><span class="fas fa-edit"></span></a></td>
          <td>{{ c.outputName }}</td>
          <td class="text-muted">{{ fieldGroupName(c.admFieldGroupId) }}</td>
          <td>{{ pathLabel(c.flattenRelationshipPath) }} <span class="text-muted">→ {{ c.flattenSourceColumnId ? columnLabel(c.flattenSourceColumnId) : "" }}</span></td>
        </tr>
        <tr *ngIf="searchedFlattenedColumns(selectedTableId).length === 0"><td></td><td class="text-muted" colspan="3">{{ flattenedSearch ? "No flattened columns match the search." : "No flattened columns on this table yet." }}</td></tr>
      </table>
    </mat-tab>

    <!-- FILTER POINTS -->
    <mat-tab label="Filter Points">
      <div class="row" style="margin-top: 10px">
        <div class="col-md-5">
          <mat-form-field class="full-width">
            <mat-label>Table</mat-label>
            <mat-select [(value)]="selectedTableId">
              <mat-option *ngFor="let t of tables" [value]="t.admTableId">{{ t.tableName }}<span *ngIf="t.retired"> (retired)</span></mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-7" style="margin-top: 10px">
          <button mat-raised-button class="piButton" (click)="newFilter()">New filter point</button>
        </div>
      </div>
      <p class="text-muted" style="margin-top: 4px">Showing filter points with at least one target column on the table above - a filter point may also target other tables.</p>

      <table class="table table-sm">
        <tr><th></th><th>Key</th><th>Type</th><th>Applies to</th></tr>
        <tr *ngFor="let f of filterPointsOf(selectedTableId)" [style.opacity]="f.retired ? 0.5 : 1">
          <td><a href="#" (click)="editFilter(f); false"><span class="fas fa-edit"></span></a></td>
          <td>{{ f.filterKey }}</td>
          <td>{{ filterTypes[f.filterType].label }}</td>
          <td>
            <span *ngFor="let id of f.targetColumnIds; let last = last">{{ columnLabel(id) }}<span *ngIf="!last">, </span></span>
            <span class="text-muted" *ngIf="!f.targetColumnIds || f.targetColumnIds.length === 0">not applied anywhere</span>
          </td>
        </tr>
        <tr *ngIf="filterPointsOf(selectedTableId).length === 0"><td></td><td class="text-muted" colspan="3">No filter points target this table yet.</td></tr>
      </table>
    </mat-tab>

    <!-- REUSE FLATTENED COLUMNS -->
    <mat-tab label="Reuse Flattened Columns">
      <admin-adm-flatten-copy (imported)="load()" (openValidation)="selectedTab = validationTabIndex"></admin-adm-flatten-copy>
    </mat-tab>

    <!-- IMPORT / EXPORT -->
    <mat-tab label="Import / Export">
      <admin-adm-transfer (imported)="load()" (openValidation)="selectedTab = validationTabIndex"></admin-adm-transfer>
    </mat-tab>

    <!-- VALIDATION -->
    <mat-tab label="Validation">
      <p class="text-muted" style="margin-top: 10px" *ngIf="issues.length === 0">The definition is valid.</p>
      <table class="table table-sm" *ngIf="issues.length > 0" style="margin-top: 10px">
        <tr><th></th><th>Where</th><th>Code</th><th>Message</th></tr>
        <tr *ngFor="let i of issues">
          <td><span class="fas" [ngClass]="i.severity === 1 ? 'fa-times-circle' : 'fa-exclamation-triangle'" [style.color]="i.severity === 1 ? '#b00020' : '#b26a00'"></span></td>
          <td>{{ i.subject }}</td>
          <td class="text-muted">{{ i.code }}</td>
          <td>{{ i.message }}</td>
        </tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>
